import { fetchEmailUsage } from '../api/firebase/users';

/**
 * Validator for the shared AddStaffMemberForm (`isEmailTaken` prop).
 *
 * With `ccms-add-staff-existing-account` on, a multi-role account that isn't
 * already staff here is allowed; the contact triggers link its uid server-side.
 */
export async function isStaffEmailTaken(
  email: string,
  organizationId: string,
  allowExistingAccount: boolean
): Promise<boolean> {
  // Contacts are stored with lowercase emails and the contact lookup is exact-match.
  const emailUsage = await fetchEmailUsage(email.trim().toLowerCase(), organizationId);
  if (allowExistingAccount && emailUsage.isMultiRole && !emailUsage.hasStaffContactInOrganization) return false;
  return emailUsage.isInUse;
}
